module.exports = __webpack_public_path__ + "static/media/dianzan.e9860cf1.svg";